import React from "react";
import GTMScriptLoader from "./GTMScriptLoader";
import GTMConsentManager from "./GTMConsentManager";

export default function GoogleTagManager() {
    return (
        <>
            <GTMScriptLoader />
            <GTMConsentManager />
        </>
    );
}
